import http from '../jslibs/axios/http';
import dkAxiosFile from '@/jslibs/axios/axios-file';

export const login = data => http.post('/cms/Login', data);
export const wxLogin = data => http.post('/cms/WechatAuth', data);
export const wxBindMobile = data => http.post('/cms/BindMobile', data);
export const sendCode = data => http.post('/cms/SendCode', data);

//获取所有菜单项
export const menulist = () => http.get('/cms/AdminAuthMenu');

//获取所有行业名称列表
export const industrylist = () => http.get('/cms/order/industry');

//获取操作列表
export const logList = data => http.get('/cms/admin/log', data);

//获取七牛信息
export const qiniuInfo = () => http.get('/cms/Communal');

export const getSetting = () => http.get('/cms/SystemSetting');
export const changeSetting = (uuid, data) => http.put(`/cms/SystemSetting/${uuid}`, data);

//上传图片
// export const uploadImg = (data)=> http.post('http(s)://upload-z2.qiniup.com', data)

export const uploadFile = data => dkAxiosFile({
  url: 'https://upload-z2.qiniup.com',
  headers: {
    'content-type': 'multipart/form-data'
  },
  method: 'POST',
  data
});